import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    // 获取优惠券配置项
    getCouponTemplateConfig: function getCouponTemplateConfig() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/coupon/template/config/get",
        method: "get",
        params: data
      });
    },
    // 新增优惠券模板
    addCouponTemplate: function addCouponTemplate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/coupon/template/add",
        method: "post",
        data: data
      });
    },
    // 更新优惠券模板状态
    updateCouponTemplateStatus: function updateCouponTemplateStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/coupon/template/status/update",
        method: "post",
        data: data
      });
    },
    // 查询优惠券模板
    getCouponTemplateList: function getCouponTemplateList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var newData = _objectSpread({}, data);
      Object.keys(newData).forEach(function (key) {
        if (newData[key] === "") {
          delete newData[key];
        }
      });
      return request({
        url: "/api/v3/admin/coupon/template/list",
        method: "get",
        params: newData
      });
    },
    // 定向往指定用户发放优惠券
    sendCouponsToTargetUsers: function sendCouponsToTargetUsers() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/coupon/template/sendCouponsToTargetUsers",
        method: "post",
        data: data
      });
    },
    // 查询优惠券发放记录
    getCouponRecordList: function getCouponRecordList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/coupon/record/list",
        method: "get",
        params: data
      });
    }
  };
});